import { render } from "./ClinicaSagradaFamilia.vue?vue&type=template&id=5b3fc410&scoped=true"
import script from "./ClinicaSagradaFamilia.vue?vue&type=script&lang=js"
export * from "./ClinicaSagradaFamilia.vue?vue&type=script&lang=js"

import "./ClinicaSagradaFamilia.vue?vue&type=style&index=0&id=5b3fc410&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b3fc410"]])

export default __exports__